import React, { useState, useEffect } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Button } from '@uhg-abyss/web/ui/Button';
import PropTypes from 'prop-types';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { config } from '@uhg-abyss/web/tools/config/config';
import { event } from '@uhg-abyss/web/tools/event';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';

const StyledErrorModalContainer = styled(Drawer.Section, {
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '120px',
  textAlign: 'center',
});

const StyledLayout = styled(Layout.Stack, {
  marginBottom: '60px !important',
});

const StyledErrorTitleText = styled(Heading, {});

const StyledErrorBodyText = styled('p', {});

const getErrorDetails = (errorCode, errorMessage, defaultErrorMessage) => {
  switch (errorCode) {
    case 'DSA:V:USR:NU':
      return {
        title: 'Your Account is not registered to a Tax Id',
        buttonText: 'Register your TIN',
        buttonHref: config('REGISTRATION_PAGE_URL'),
        errorMessage,
      };
    case 'DSA:V:USR:IR':
      return {
        title: 'Your profile has been deactivated',
        buttonText: 'Organization & Tax ID Access',
        buttonHref: '#/prefcenter/orgtaxIdAccess',
        errorMessage,
      };
    case 'DSA:V:USR:PR':
      return {
        title: 'Your access is pending approval',
        buttonText: 'Organization & Tax ID Access',
        buttonHref: '#/prefcenter/orgtaxIdAccess',
        errorMessage,
      };
    default:
      return {
        title: 'Service Unavailable',
        buttonText: 'Retry',
        buttonHref: '#',
        variant: 'outline',
        errorCode: '',
        errorMessage: defaultErrorMessage,
      };
  }
};

const handleButtonClick = (
  errorCode,
  buttonText,
  buttonHref,
  toggleProvider,
  errorMessage,
  defaultErrorMessage
) => {
  if (errorMessage === defaultErrorMessage) {
    window.location.reload();
  } else if (errorCode === 'DSA:V:USR:NU') {
    window.open(config('REGISTRATION_PAGE_URL', '_blank'));
    event('EXIT_LINK_NAVIGATE', {
      linkText: buttonText,
      linkUrl: buttonHref,
    });
  } else {
    event('NAVIGATION_CLICK', { name: buttonText });
    window.location.href = '#/prefcenter/orgtaxIdAccess';
  }
  toggleProvider(false);
};

export const ProviderSelectDrawerErrorModal = ({
  errorCode,
  errorMessage,
  toggleProvider,
}) => {
  const { getMessage } = usePPDLagoon();
  const [defaultErrorMessage, setDefaultErrorMessage] = useState('');

  useEffect(() => {
    setDefaultErrorMessage(getMessage('provider-drawer-default-error'));
  }, [errorCode]);

  const {
    title,
    buttonText,
    buttonHref,
    variant,
    errorMessage: errMessage,
  } = getErrorDetails(errorCode, errorMessage, defaultErrorMessage);

  return (
    <StyledErrorModalContainer>
      <StyledLayout space={20} alignLayout="center">
        <IconBrand size={50} icon="alert" />
        <StyledErrorTitleText offset={2}>{title}</StyledErrorTitleText>
        <StyledErrorBodyText>{errMessage}</StyledErrorBodyText>
        <Button
          variant={variant}
          onClick={() =>
            handleButtonClick(
              errorCode,
              buttonText,
              buttonHref,
              toggleProvider,
              errMessage,
              defaultErrorMessage
            )
          }
        >
          {buttonText}
        </Button>
      </StyledLayout>
    </StyledErrorModalContainer>
  );
};

ProviderSelectDrawerErrorModal.propTypes = {
  errorCode: PropTypes.string,
  errorMessage: PropTypes.string,
  toggleProvider: PropTypes.func.isRequired,
};

ProviderSelectDrawerErrorModal.defaultProps = {
  errorCode: '',
  errorMessage: '',
};
